"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockTournament = void 0;
const __1 = require("..");
const species_1 = require("./species");
function mockTournament(overrides = {}) {
    return {
        contact: 'joey joe joe',
        description: '<p>its a tournament</p>',
        email: 'email@example.com',
        end_date: '2019-05-05',
        entry_fee: '20',
        estimated_boats: '300',
        estimated_entrants: '300',
        estimated_prize: '1000',
        id: 1,
        launch: 'mock launch',
        organization_other: 'mock organization_other',
        organization: (0, __1.mockOrganization)(),
        permit_number: '1234',
        phone: '123-456-7890',
        qualification_info: 'mock qualification_info',
        results_recap: 'mock results_recap',
        series_name: 'mock series_name',
        slug: 'bass-catchers-2019-05-01',
        species: [(0, species_1.mockSpecies)()],
        start_date: '2019-05-01',
        time_descriptions: '<p>day 1: 1:00</p>',
        title: 'bass catchers',
        url: 'http://example.com/bass',
        waterbodies: [(0, __1.mockWaterbody)()],
        ...overrides,
    };
}
exports.mockTournament = mockTournament;
